import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetToken } from "../actions/userAction";
import axios from "axios";
const useUpload = () => {
  const dispatch = useDispatch();
  const selector = useSelector((state) => state);
  const [token, setToken] = useState("");

  useEffect(() => {
    dispatch(GetToken());
  }, []);

  useEffect(() => {
    setToken(selector?.adminReducer?.token);
  }, [selector]);

  const upload = (file) => {
    const url = "https://assets.thelexpedia.com//wp-json/wp/v2/media";
    const config = {
      headers: {
        Authorization: `Bearer  ${token}`,
      },
    };
    const body = new FormData();
    body.append("file", file);
    return axios.post(url, body, config);
  };

  return {
    upload,
  };
};

export default useUpload;
